import "core-js/modules/es.array.push.js";
import AgoraClient from '@/assets/js/rtc-client-ng';
import { mapState } from 'vuex';
import { handleLocalStorage } from '@/assets/js/utils.js';
export default {
  data() {
    return {
      joinLoading: false,
      mute: false,
      voiceVal: 100,
      rtilCode: '',
      hostRtilCode: '',
      rtc: null,
      partyCode: '',
      manageRtilCode: [],
      changeRtilCode: '',
      realManageRtilCode: [],
      localVideoTrack: null,
      localAudioTrack: null,
      devicesInfo: [],
      channels: {},
      MeInfo: {}
    };
  },
  computed: {
    ...mapState({
      State: state => state,
      loginInfo: state => state.loginInfo,
      Config: state => state.config
    })
  },
  watch: {
    voiceVal: {
      immediate: true,
      handler(newVal) {
        if (newVal == 0) {
          this.mute = true;
        } else {
          this.mute = false;
        }
      }
    },
    changeRtilCode(newVal, oldVal) {
      if (!newVal) return;
      if (oldVal && this.rtc) {
        this.rtc.unsubscribe(oldVal, 'audio');
        this.rtc.unsubscribe(oldVal, 'video');
      }
    }
  },
  async created() {
    this.rtc = new AgoraClient(this.agoraCallback);
  },
  methods: {
    setAudio(key) {
      if (this.channels[this.changeRtilCode]) {
        if (key === 'mute') {
          this.mute = true;
          this.voiceVal = 0;
          this.channels[this.changeRtilCode].audioTrack.setVolume(0);
        } else {
          this.mute = false;
          this.voiceVal = 100;
          this.channels[this.changeRtilCode].audioTrack.setVolume(100);
        }
      }
    },
    setVideoAudio(audioVal) {
      if (this.channels[this.changeRtilCode] && !isNaN(audioVal)) {
        this.channels[this.changeRtilCode].audioTrack.setVolume(audioVal);
      }
    },
    subscribeRtil(data) {
      this.voiceVal = 100;
      this.changeRtilCode = data;
      if (data != this.hostRtilCode) {
        var _this$rtc, _this$rtc2;
        (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc.subscribe(data, 'audio');
        (_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2.subscribe(data, 'video', 'unExecuteCallback');
      }
    },
    leave() {
      this.rtc && this.rtc.leave();
      this.realManageRtilCode = [];
      this.manageRtilCode = [];
      this.changeRtilCode = '';
      this.rtilCode = '';
      this.$message({
        message: this.$t('debugPage.leaveSuccess'),
        type: 'success'
      });
    },
    join() {
      this.joinLoading = true;
      if (this.rtc) this.rtc.leave();
      const data = new Date().getTime();
      const memberId = 'PL_Debug_' + data;
      const params = {
        type: 0,
        memberId: memberId,
        partyCode: this.partyCode,
        role: 0
      };
      const protocol = window.location.protocol;
      const url = `${protocol}//${this.Config.urlInfo['gateway.url']}/rtil/party/joinParty`;
      this.axios.post(url, params, {
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.joinParam = {
            ...result,
            partyCode: this.partyCode,
            memberId: params.memberId
          };
          this.joinAgoraClient(result, this.joinParam);
        } else {
          this.$message({
            type: 'error',
            message: res.data.errorInfo
          });
          this.joinLoading = false;
        }
      }).catch(e => {
        this.$message({
          type: 'error',
          message: e
        });
        this.joinLoading = false;
      });
    },
    async joinAgoraClient(result, param) {
      // 创建通知websocket
      if (!this.State.pageSerBusRequestWs[this.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.partyCode
        });
      }
      this.getMeetingInfo(param);
    },
    async getMeetingInfo(param) {
      const {
        appId,
        tokenCode,
        rtilCode
      } = param;
      const params = {
        appId,
        channel: this.partyCode + '',
        // videoConfig: videoQualities,
        // 传入用户选择的可用的音视频采集设备的id
        // cameraId: this.devicesInfo.cameraId,
        // microphoneId: this.devicesInfo.microphoneId,
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        publishVideo: !this.noCamera,
        publishAudio: !this.noAudio,
        // 不能再根据当前是否有媒体设备来创建 track
        // 还要添加当前是否处于禁止状态
        // 极少数会出现 mute camera 了并且 camera 还被占了，这个时候创建会报错，而且会有即使 mute 了 camera 但是摄像头灯还在亮的问题
        video: false,
        audio: false,
        getRemoteNetworks: true,
        // 刚进来谁都不订阅
        subscribeRemote: false,
        executeLocalSubscribe: true,
        publish: false,
        videoConfig: [{
          width: 30,
          height: 400,
          frameRate: 15,
          bitrate: 30
        }]
      };
      const uid = await this.rtc.join(params);
      if (uid) {
        this.hadOpenWebCloud = true;
        this.rtcLoaded = true;
        this.hostRtilCode = rtilCode;
        this.State.currentRtilCode = rtilCode;
      }
    },
    async userJoin(payload) {
      if (payload.id) {
        this.manageRtilCode.push(payload.id);
      }
      this.manageRtilCode.forEach(item => {
        if (!this.realManageRtilCode.includes(item)) {
          this.realManageRtilCode.push(item);
        }
      });
      this.joinLoading = false;
    },
    subscribeTrack(payload) {
      const {
        videoTrack,
        audioTrack
      } = payload;
      this.MeInfo = {
        id: payload.id,
        tid: handleLocalStorage('get', 'memberId'),
        info: {
          rtilCode: payload.id
        },
        channel: this.partyCode,
        videoTrack: videoTrack,
        audioTrack: audioTrack
      };
      this.$set(this.channels, payload.id, this.MeInfo);
      if (audioTrack) {
        this.rtc.play && this.rtc.play(audioTrack, '', {
          type: 'audio'
        });
      }
      if (videoTrack) {
        this.rtc && this.rtc.play && this.rtc.play(videoTrack, '', {
          videoBox: this.$refs.videoTest,
          type: 'video'
        });
      }
    },
    userPublished(action, payload) {
      const {
        videoTrack,
        audioTrack
      } = payload.remoteUser;
      if (audioTrack && this.rtc) {
        this.rtc.subscribe(payload.id, 'audio');
        this.rtc.play && this.rtc.play(audioTrack, '', {
          type: 'audio'
        });
      }
      if (videoTrack && this.rtc) {
        this.rtc.subscribe(payload.id, 'video', 'unExecuteCallback');
        this.rtc && this.rtc.play && this.rtc.play(videoTrack, '', {
          videoBox: this.$refs.videoTest,
          type: 'video'
        });
      }
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      this.realManageRtilCode = this.realManageRtilCode.filter(v => v != id);
    },
    async agoraCallback({
      action,
      payload
    }) {
      switch (action) {
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          this.localAudioTrack = audioTrack;
          this.localVideoTrack = videoTrack;
          if (!this.realManageRtilCode.includes(payload.id)) {
            this.realManageRtilCode.push(payload.id);
            this.joinLoading = false;
            this.$message({
              message: this.$t('debugPage.joined'),
              type: 'success'
            });
          }
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.userPublished(action, payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
      }
    }
  }
};